import { AutoTextSize } from 'utils/autoTextSizeUtils';
import { StyledSubProduct } from './style';

interface IBabaSubProductProps {
  textFontColorHex: string;
  quantityDisplay: string;
  images: Record<string, string>;
  isLastInRow: boolean;
}

export const BabaSubProduct: React.FC<IBabaSubProductProps> = ({
  textFontColorHex,
  quantityDisplay,
  images,
  isLastInRow,
}) => {
  return (
    <StyledSubProduct
      color={textFontColorHex}
      gap={'4px'}
      className={'baba-sub-product'}
      rightBorder={!isLastInRow}
    >
      <img className="product" src={images.product} alt="product" />
      <div className="quantity-wrapper">
        <AutoTextSize mode="oneline" maxFontSizePx={14} minFontSizePx={10}>
          <p className="quantity">{quantityDisplay}</p>
        </AutoTextSize>
      </div>
    </StyledSubProduct>
  );
};
